<template>
  <div class="flex flex-col justify-between w-full h-screen">
    <HeaderBar />
    <div id="index" class="flex flex-col items-center">
      <PageTitle :text="'Dressing modulaire'" :logo="true" />
      <PageDescription :text="this.description" />
      <router-link id="new-project-button" class="my-8" to="/new-configuration">
        <GenericButton :text="'Créer mon dressing en quelques clics !'" :icon="'play'" />
      </router-link>
    </div>
    <FooterBar />
  </div>
</template>

<script>
import HeaderBar from '@/components/HeaderBar.vue';
import FooterBar from '@/components/FooterBar.vue';
import GenericButton from '@/components/ui/GenericButton.vue';
import PageTitle from '@/components/ui/PageTitle.vue';
import PageDescription from '@/components/ui/PageDescription.vue';

export default {
  name: 'Index',
  components: {
    HeaderBar,
    FooterBar,
    GenericButton,
    PageTitle,
    PageDescription,
  },
  data() {
    return {
      description: 'Modélisez le dressing de vos rêves en quelques clics grâce à notre application de personnalisation sur mesure !',
    };
  },
};
</script>
